import { fmt, fmtDateTime, fmtSar, fmtTime, labelOf } from "./coUtils";

function payState(t, key) {
    if (!key) return "";
    const k = `co_pos_pay_state_${key}`;
    return t(k) === k ? key : t(k);
}

/** The record's `pos` block in plain words (message 29 §3 record panel). */
export function posLines(pos, t, lang, labels) {
    const p = pos || {};
    const out = [];
    if (p.match === "matched") {
        out.push(fmt(t("co_rec_pos_matched_line"), {
            total: fmtSar(p.total_halalas, lang), state: payState(t, p.pay_state), time: fmtTime(p.pos_time, lang) }));
        if (p.match_basis) out.push(t(`co_rec_pos_basis_${p.match_basis}`));
        if (p.order_channel && p.order_channel !== "unknown") {
            out.push(fmt(t("co_rec_pos_channel"), { channel: labelOf(labels?.sources, p.order_channel, lang) }));
        }
        if (p.till?.count) out.push(fmt(t("co_rec_pos_till_line"), { count: p.till.count, amount: fmtSar(p.till.amount_halalas, lang) }));
        if (p.value_exceeds) out.push(t("co_rec_pos_value_exceeds"));
        else if (p.partial) out.push(t("co_rec_pos_partial"));
        if (p.anomaly === "source_mismatch") out.push(t("co_rec_pos_source_mismatch"));
    } else if (p.match === "not_found") {
        out.push(t(p.anomaly === "not_found" ? "co_rec_pos_not_found_final" : "co_rec_pos_not_found_wait"));
    } else if (p.match === "ambiguous") {
        out.push(p.candidates_count >= 2 ? fmt(t("co_rec_pos_ambiguous_many"), { n: p.candidates_count }) : t("co_rec_pos_ambiguous_short"));
    } else {
        out.push(t("co_rec_pos_unavailable_line"));
    }
    if (p.checked_at) out.push(fmt(t("co_rec_pos_checked"), { at: fmtDateTime(p.checked_at, lang) }));
    return out;
}

export function PosPlain({ pos, labels, t, lang, testId }) {
    const lines = posLines(pos, t, lang, labels);
    return (
        <div data-testid={testId} data-match={pos?.match || "unavailable"} className="space-y-1">
            {lines.map((l, i) => (
                <p key={i} className={i === 0 ? "text-sm font-semibold text-[color:var(--ink)]" : "text-xs text-[color:var(--ink-muted)]"}>{l}</p>
            ))}
        </div>
    );
}
